<template>
  <div class="profile-page">
    <van-nav-bar fixed placeholder class="page-nav" :border="false">
      <template #title>
        <span class="page-title">Personal Center</span>
      </template>
      <template #right>
        <van-icon name="home-o" class="home-icon" @click="$router.push('/Home')" />
      </template>
    </van-nav-bar>

    <div class="profile-content">
      <section class="profile-hero">
        <div class="hero-top">
          <div class="user-block">
            <img :src="displayHeaderImg" alt="avatar" class="user-avatar" @error="onAvatarError">
            <div class="user-name">{{ userInfo.username || 'Guest' }}</div>
          </div>

          <van-icon name="edit" class="edit-icon" @click="$router.push('/Infomation')" />
        </div>

        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-label">Points</div>
            <div class="stat-value notranslate" translate="no">{{ formatMoneyValue(userInfo.money) }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">Credit Score</div>
            <div class="stat-value notranslate" translate="no">{{ formatIntegerValue(userInfo.xinyu) }}</div>
          </div>
          <div class="stat-item">
            <div class="stat-label">Video Views</div>
            <div class="stat-value notranslate" translate="no">{{ videoViews }}</div>
          </div>
        </div>
      </section>

      <section class="vip-banner">
        <div class="vip-title">Join Exclusive Membership</div>
        <div class="vip-desc">Single Payment, Lifetime Access</div>
      </section>

      <section class="menu-panel">
        <button
          v-for="item in menuItems"
          :key="item.label"
          class="menu-item"
          @click="handleMenuClick(item)"
        >
          <span>{{ item.label }}</span>
          <van-icon name="arrow" />
        </button>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      avatarFallback: false,
      menuItems: [
        { label: 'Recharge', path: '/Recharge' },
        { label: 'Withdraw', path: '/Withdraw' },
        { label: 'Wallet Management', path: '/BindCard' },
        { label: 'Withdraw Record', path: '/WithdrawRecord' },
        { label: 'Recharge Record', path: '/RechargeList' },
        { label: 'Order Record', path: '/GameRecord' },
        { label: 'System Notifications', path: '/Notice' },
        { label: 'Logout', action: 'logout' }
      ]
    };
  },
  computed: {
    displayHeaderImg() {
      if (this.avatarFallback) {
        return 'https://m.sincereloves.online/logo.png';
      }

      const url = this.normalizeAssetUrl(this.userInfo.header_img);
      return url || 'https://m.sincereloves.online/logo.png';
    },
    videoViews() {
      return this.formatIntegerValue(
        this.userInfo.watch_num || this.userInfo.video_num || this.userInfo.look_num || 0,
      );
    }
  },
  methods: {
    formatMoneyValue(value) {
      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        return numericValue.toFixed(2);
      }
      return '0.00';
    },
    formatIntegerValue(value) {
      const numericValue = Number(value);
      if (Number.isFinite(numericValue)) {
        return String(Math.trunc(numericValue));
      }
      return '0';
    },
    normalizeAssetUrl(url) {
      if (!url || typeof url !== 'string') {
        return '';
      }

      const origin = 'https://admin.whtas.me';

      if (/^https?:\/\/127\.0\.0\.1\//.test(url)) {
        return url.replace(/^https?:\/\/127\.0\.0\.1\//, `${origin}/`);
      }

      if (/^https?:\/\/localhost:8081\//.test(url)) {
        return url.replace(/^https?:\/\/localhost:8081\//, `${origin}/`);
      }

      if (url.startsWith('/')) {
        return `${origin}${url}`;
      }

      return url;
    },
    onAvatarError() {
      this.avatarFallback = true;
    },
    handleMenuClick(item) {
      if (item.action === 'logout') {
        const token = localStorage.getItem('token');
        if (token) {
          sessionStorage.removeItem(`login_intro_shown_${token}`);
        }
        localStorage.clear();
        this.$cookies.remove('token');
        this.$router.push('/Login');
        return;
      }

      this.$router.push(item.path);
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then((res) => {
        if (res.code === 200) {
          this.avatarFallback = false;
          this.userInfo = res.data || {};
          if (this.userInfo.status !== 1 && this.userInfo.is_online !== 1) {
            this.$toast(this.$t('video.account_out'));
            localStorage.clear();
            this.$router.push({ path: '/Login' });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo = {
        username: 'Guest',
        money: '0.00',
        xinyu: '0',
        header_img: ''
      };
    }
  }
};
</script>

<style lang="less" scoped>
.profile-page {
  min-height: 100vh;
  padding-bottom: 126px;
  background: linear-gradient(180deg, #030d24 0%, #000 42%, #000 100%);
  color: #fff;
}

.page-nav {
  min-height: 96px;
  background: #1c1c1e;
}

::v-deep .page-nav .van-nav-bar {
  background: #1c1c1e;
  box-shadow: none;
}

::v-deep .page-nav .van-nav-bar__content {
  height: 96px;
}

.page-title {
  color: #e6b98a;
  font-size: 28px;
  font-weight: 700;
}

.home-icon {
  color: #e6b98a;
  font-size: 34px;
}

.profile-content {
  min-height: calc(100vh - 170px);
  padding-bottom: 20px;
  background: transparent;
}

.profile-hero {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(230, 185, 138, 0.18);
  background:
    radial-gradient(circle at top left, rgba(239, 199, 155, 0.18), transparent 34%),
    linear-gradient(180deg, #15233a 0%, #0a1325 100%);
}

.hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 18px 16px;
}

.user-block {
  display: flex;
  align-items: center;
}

.user-avatar {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 3px solid rgba(239, 199, 155, 0.75);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  object-fit: cover;
}

.user-name {
  margin-left: 18px;
  color: #f7d2ab;
  font-size: 24px;
  font-weight: 700;
}

.edit-icon {
  color: #efc79b;
  font-size: 30px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0 16px;
  overflow: hidden;
  border: 1px solid rgba(239, 199, 155, 0.24);
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(20, 30, 48, 0.95), rgba(34, 39, 50, 0.92));
}

.stat-item {
  padding: 18px 10px 20px;
  text-align: center;
}

.stat-item + .stat-item {
  border-left: 1px solid rgba(239, 199, 155, 0.12);
}

.stat-label {
  color: rgba(247, 210, 171, 0.78);
  font-size: 18px;
  font-weight: 600;
}

.stat-value {
  margin-top: 10px;
  color: #fff4e7;
  font-size: 26px;
  font-weight: 800;
}

.vip-banner {
  margin: 18px 16px 0;
  padding: 28px 28px 30px;
  border: 1px solid rgba(239, 199, 155, 0.24);
  border-radius: 22px;
  background:
    linear-gradient(90deg, rgba(15, 20, 31, 0.94), rgba(44, 40, 35, 0.88)),
    url('/img/neww/user-bg.png') no-repeat right center / cover;
  color: #f2c28f;
}

.vip-title {
  color: #ffd39f;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.18;
}

.vip-desc {
  margin-top: 6px;
  color: rgba(255, 223, 190, 0.92);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.25;
}

.menu-panel {
  margin: 18px 16px;
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(239, 199, 155, 0.18);
  background: linear-gradient(180deg, #171b23, #101319);
}

.menu-item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 30px 24px;
  border: none;
  border-bottom: 1px solid rgba(239, 199, 155, 0.1);
  background: transparent;
  color: #f7d2ab;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item .van-icon {
  color: #efc79b;
  font-size: 32px;
}
</style>
